// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-text-mail[data-v-edffb9b8]{padding:9px 0 13px 0;font-size:1.6rem;font-weight:bold;color:#707070}", ""]);
// Exports
module.exports = exports;
